import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import load from "../../assets/Images/loader.gif";
import * as api from "../../api_function";


const optionLost = [
  // { name: "Disqualify", code: "" },
  { name: "Select reason for cancellation", code: "569480018" },
  { name: "Required Solution not Available", code: "569480017" },
  { name: "Customer Found Our Product Costly", code: "569480006 " },
  { name: "Location Is Non-RFS", code: "569480007" },
  { name: "Customer Looking For Promotional Offers", code: "569480008 " },
  { name: "Customer Wanted Information Only", code: "569480009" },
  { name: "Existing Customer", code: "569480010" },
  { name: "Customer Do Not Have Required Documents", code: "569480011" },
  { name: "Customer Is defaulter", code: "569480012 " },
  { name: "Duplicate Lead", code: "569480000 " },
  { name: "Incorrect Demographic Details", code: "569480001" },
  { name: "Broadband-Home User", code: "569480002" },
  { name: "Customer Not Interested", code: "569480003" },
  { name: "Customer Moved To Other Service Provider", code: "569480004" },
  { name: "Delay in Response", code: "569480005" },
  { name: "Canceled", code: "4" },
  { name: "Out-Sold", code: "5" },
];

const optionSolutation = [
  { label: "Select Salutation", value: "0" },
  { label: "Mr.", value: "1" },
  { label: "Mrs.", value: "2" },
  { label: "Miss", value: "3" },
];

const optionTurnOver = [
  { label: "Select Option", value: "0" },
  { label: "Diamond (>250Cr)", value: "111260000" },
  { label: "Emerald (100Cr-250Cr)", value: "111260001" },
  { label: "Ruby (10Cr-100Cr)", value: "111260002" },
  { label: "Bronze (1Cr-10Cr)", value: "111260003" }
]

const optionCountry = [{ label: "India", value: "10001" }];

const optionState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const optionCustomerSeg = [
  { label: "Select Customer Segment", value: "0" },
  { label: "SDWAN", value: "111260004" },
  { label: "SMB", value: "111260000" },
  { label: "Media", value: "111260001" },
  { label: "LA", value: "111260002" },
  { label: "SP", value: "111260003" },
];

const OpportunityForm = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
  };

  const [activeForm, setActiveForm] = useState("form1");
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [productOptions, setProductOptions] = useState([]);
  const [selectedPriceList, setSelectedPriceList] = useState("");
  const [priceListOptions, setPriceListOptions] = useState([]);
  const [leadid, setleadid] = useState("");
  const [industrydropdetails, setindustrydropdetails] = useState([]);
  const [selectIndustry, setSelectIndustry] = useState();
  const [selectSociety, setSelectSociety] = useState("");
  const [societyList, setSocietyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loader, setLoader] = useState(false);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectSolutaton, setSelectSolutaton] = useState(optionSolutation[0]);
  const [statusCode, setStatusCode] = useState("")
  const [status, setStatus] = useState("")
  const [selectCountry, setSelectCountry] = useState("");
  const [selectState, setSelectState] = useState("");
  const [selectCity, setSelectCity] = useState("");
  const [cityType, setCityType] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [selectCustomerSeg, setSelectCustomerSeg] = useState(optionCustomerSeg[0]);
  const [selectTurnOver, setSelectTurnOver] = useState(optionTurnOver[0]);
  const [otcAmount, setOtcAmount] = useState("");
  const [sdAmount, setSdAmount] = useState("");
  const [otcAmountDis, setOtcAmountDis] = useState("");
  const [sdAmountDis, setSdAmountDis] = useState("");

  const [getOppProduct, setOppProduct] = useState("");
  // const [flag, setflag] = useState(false);

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompany(selectedOption);
  };

  const handlePriceListChange = (selectOption) => {
    setSelectedPriceList(selectOption);
  };

  const handleIndustryChnage = (selected) => {
    setSelectIndustry(selected);
  };

  const handleSelectSolutation = (selectSolutation) => {
    setSelectSolutaton(selectSolutation);
  };

  const handleSelectCountry = (selectOption) => {
    setSelectCountry(selectOption);
  };

  const handleSelectState = (selectOption) => {
    setSelectState(selectOption);
  };

  const handleSelectCustomerSeg = (selectCustomerSeg) => {
    setSelectCustomerSeg(selectCustomerSeg);
  };

  const handleSelectTurnOver = (selectTurnOver) => {
    setSelectTurnOver(selectTurnOver);
  };


  const [opportunityData, setOpportunityData] = useState({
    Remarks: "",
    Redunancy: false,
    Block: "",
    Status: "",
    Statuscode: "",
    OppId: "",
    OppStatus: "",
    LeadId: "",
    PriceList: "",
    Topic: "",
    StateId: "",
    CityId: "",
    AreaId: "",
    BuildingId: "",
    SpecificArea: "",
    SpecificBuilding: "",
    Building_BuildingStatus: "",
    NoOfUsers: "",
    NoOfBeds: "",
    IndustryId: "",
    ApprovalRequiredFlag: "",
    Reason: "",
    Area: "",
    Subbusinesssegment: "",
    Businesssegment: "",
    State: "",
    Salutation: "",
    Relationship: "",
    PostalCode: "",
    Mobilephone: "",
    Media: "",
    Lco: null,
    Industry: "",
    Group: "",
    Floor: "",
    TPFeasibilty: "",
    CreateAreaOrBuilding: false,
    Firmtype: "",
    Product: "",
    ProductSegment: "",
    FeasibilityRequired: false,
    Existingprovider: "",
    Emailaddress: "",
    Country: "",
    Companyname: "",
    City: "",
    leadname: "",
    Buildingname: "",
    BuildingNo: "",
    ContactPerson: "",
    CustomerSegment: "",
    LastMileType: "",
    UpTimesla: "",
    Firewall: "",
    CompanySelf: "",
    PoLock: "",
    Price: "",
    OriginatingLead: "",
    FirewallAwc: "",
    PoNext: "",
    Company: "",
    TotalAmount: "",
    VerticalID: "",
    TypeOfOrder: "",
    PocClosureDate: "",
    TurnOver: "",
    SocietyName: "",
    SocietyId: "",
    SocietyStatus: "",
    HousePlotFlatNo: "",
    BlockTowerNumber: "",
    OTCAmount: "",
    SDAmount: "",
    RCAmount: "",
    sdDiscount: "",
    otcDiscount: "",
    exOtcDiscount: "",
    exsdDiscount: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOpportunityData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectSociety = (selectSociety) => {
    setSelectSociety(selectSociety);
  };

  const handleCreateCaf = () => {
    // console.log("leadid", leadid);
    navigate(`/broadbandCAFmanageForm?OppId=${OppId}&leadId=${leadid}`)
  };






  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };


  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const OppId = searchParams.get("OppId");
  const navigate = useNavigate();
  // const redirectLeadPage = () => {
  //   navigate("/businessLead");
  // };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getopportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: "",
          OppId: OppId ? OppId : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responsedata = await response.json();
        const responseData = responsedata?.Response?.Data?.[0];
        // console.log("getOppotunity", responseData);
        // console.log("getLeads1" ,responsedata1);
        // console.log("responseData.OppId", responseData.OppId);
        sessionStorage.setItem("opportunityId", responseData.OppId);
        if (responsedata?.Status === "Success" && responseData) {
          setOppProduct(responseData.Product)
          if (responseData?.Company) {
            setSelectedCompany({
              value: responseData.Company,
              label: responseData.Company,
            });
          }
          setOpportunityData({

            Remarks: responseData.Remarks || "",
            Redunancy: responseData.Redunancy || false,
            Block: responseData.Block || "",
            Status: responseData.Status || "",
            Statuscode: responseData.Statuscode || "",
            OppId: responseData.OppId || "",
            OppStatus: responseData.Statuscode || "",
            LeadId: responseData.LeadId || "",
            PriceList: responseData.PriceList || "",
            Topic: responseData.Topic || "",
            BuildingId: responseData.BuildingId || "",
            SpecificArea: responseData.SpecificArea || "",
            SpecificBuilding: responseData.SpecificBuilding || "",
            Building_BuildingStatus: responseData.Building_BuildingStatus || "",
            NoOfUsers: responseData.NoOfUsers || "",
            NoOfBeds: responseData.NoOfBeds || "",
            ApprovalRequiredFlag: responseData.ApprovalRequiredFlag || "",
            Reason: responseData.Reason || "",
            Subbusinesssegment: responseData.Subbusinesssegment || "",
            Businesssegment: responseData.Businesssegment || "",
            Relationship: responseData.Relationship || "",
            PostalCode: responseData.PostalCode || "",
            Mobilephone: responseData.Mobilephone || "",
            Media: responseData.Media || "",
            Lco: responseData.Lco || null,
            Group: responseData.Group || "",
            Floor: responseData.Floor || "",
            TPFeasibilty: responseData.TPFeasibilty || "",
            CreateAreaOrBuilding: responseData.CreateAreaOrBuilding || false,
            Firmtype: responseData.Firmtype || "",
            ProductSegment: responseData.ProductSegment || "",
            FeasibilityRequired: responseData.FeasibilityRequired || false,
            Existingprovider: responseData.Existingprovider || "",
            Emailaddress: responseData.Emailaddress || "",
            Companyname: responseData.leadname || "",
            leadname: responseData.leadname || "",
            Buildingname: responseData.Buildingname || "",
            BuildingNo: responseData.BuildingNo || "",
            ContactPerson: responseData.ContactPerson || "",
            CustomerSegment: responseData.CustomerSegment || "",
            LastMileType: responseData.LastMileType || "",
            UpTimesla: responseData.UpTimesla || "",
            Firewall: responseData.Firewall || "",
            PoLock: responseData.PoLock || "",
            Price: responseData.Price || "",
            OriginatingLead: responseData.OriginatingLead || "",
            FirewallAwc: responseData.FirewallAwc || "",
            PoNext: responseData.PoNext || "",
            TotalAmount: responseData.TotalAmount || "",
            VerticalID: responseData.VerticalID || "",
            TypeOfOrder: responseData.TypeOfOrder || "",
            PocClosureDate: responseData.PocClosureDate || "",
            TurnOver: responseData.TurnOver || "",
            SocietyName: responseData.SocietyName || "",
            SocietyId: responseData.SocietyId || "",
            SocietyStatus: responseData.SocietyStatus || "",
            HousePlotFlatNo: responseData.HousePlotFlatNo || "",
            BlockTowerNumber: responseData.BlockTowerNumber || "",
            OTCAmount: responseData.OTCAmount || "",
            SDAmount: responseData.SDAmount || "",
            RCAmount: responseData.RCAmount || "",
            sdDiscount: responseData.SDDiscountAmount || "",
            otcDiscount: responseData.OTCDiscountAmount || "",
            exOtcDiscount: responseData.OTCExtendedAmount || "",
            exsdDiscount: responseData.SDExtendedAmount || ""
          });
          setOtcAmount(responseData.OTCAmount);
          setSdAmount(responseData.SDAmount);
          setOtcAmountDis(responseData.OTCDiscountAmount);
          setSdAmountDis(responseData.SDDiscountAmount);
          setleadid(responseData.LeadId);
          // setSelectedPriceList(responseData.PriceList);
          // console.log("responseData.Product", responseData.Product)
          setStatusCode(responseData.Statuscode);
          setStatus(responseData.Status);
          setSelectSociety({
            value: responseData.SocietyId,
            label: responseData.SocietyName,
          });

          const filterSalutationId = optionSolutation.find(
            (item) => item.value === String(responseData.Salutation)
          ).label;
          setSelectSolutaton({
            value: responseData.Salutation,
            label: filterSalutationId,
          });
          // const filterProduct = productOptions.find((item) => item.value === String(responseData.Product)).label;
          setSelectedProduct({
            value: responseData.Product,
            label: responseData.Product,
          });
          setSelectedPriceList(
            {
              value: responseData.PriceList,
              label: responseData.PriceList,
            }
          )
          setSelectCountry({
            value: responseData.Country,
            label: responseData.Country,
          });
          setSelectState({
            value: responseData.StateId,
            label: responseData.State,
          })
          setSelectCity({
            value: responseData.CityId,
            label: responseData.City,
          })
          setSelectArea({
            value: responseData.AreaId,
            label: responseData.Area,
          })
          setSelectIndustry({
            value: responseData.IndustryId,
            label: responseData.Industry,
          })

          const filterCustomerSegment = optionCustomerSeg.find(item => item.value === String(responseData.CustomerSegment)).label;


          setSelectCustomerSeg(
            {
              value: responseData.CustomerSegment,
              label: filterCustomerSegment,
            });
          // console.log("responseData.TurnOver",responseData.TurnOver);

          const filterTurnOver = optionTurnOver.find(item => item.value === String(responseData?.TurnOver)).label;
          // console.log("filterTurnOver",filterTurnOver);

          setSelectTurnOver(
            {
              value: responseData.TurnOver,
              label: filterTurnOver,
            });


        } else {
          console.error("Error fetching opportunity data:", responseData?.Message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleWon = async () => {

    if (selectedProduct.value == "") {
      toast.warning("Please Select Product list", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectTurnOver.value == "0") {
      toast.warning("Please Select Turn Over", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else {
      setLoading(true);
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "wonOpportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          oppid: OppId ? OppId : "",
          password: sessionStorage.getItem('password'),
          reason: opportunityData.Reason ? opportunityData.Reason : "",
          siteId: "",
          userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const data = await response.json();

        // Check for a successful API response
        if (data.Response.StatusCode === 200) {

          toast.success("Opportunity marked as Won", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });

        } else {
          toast.warning(data.Response.Message, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });

        }
      } catch (error) {
        console.error("Error during API call:", error);
      } finally {
        setLoading(false);
        window.location.reload();
      }
    }
  };

  const handleLost = async () => {
    // console.log("Opportunity marked as Lost");
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData =
      {
        "Action": "lostOpportunity",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "Oppid": OppId,
        "password": sessionStorage.getItem('password'),
        "status": "569480010",
        "userName": sessionStorage.getItem('userName')
      }
      // console.log(requestData);return


      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      // console.log(data);

      // Check for a successful API response
      if (data.Response.StatusCode === 200) {
        toast.success("Opportunity marked as Lost", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        // window.location.reload()
        navigate(`/opportunity`);

      } else {
        toast.warning(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSendToApproval = () => {
    try {
      Swal.fire({
        title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
        text: "Please submit for approval as discount added in OTC or SD amount",
        confirmButtonText:
          '<span style="font-size: 15px;">Submit for Approval</span>',
        confirmButtonColor: "rgb(148,101,170)",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { value: formValues } = await Swal.fire({
            title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Discount</div>`,
            // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
            html: `
                                              <input id="swal-input1" class="swal2-input">  `,
            focusConfirm: false,
            preConfirm: () => {
              // return [document.getElementById("swal-input1").value];
              const reason = document.getElementById("swal-input1").value.trim();
              if (!reason) {
                Swal.showValidationMessage("Reason is required.");
                return;
              }
              return reason;
            }
          });
          if (formValues) {
            const ApiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
              "Action": "BBApprovalProcessDigi",
              "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              "userName": sessionStorage.getItem('userName'),
              "password": sessionStorage.getItem('password'),
              "OpportunityID": OppId ? OppId : "",
              "ApprovalRemarks": formValues
            };
            const Response = await fetch(ApiUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestBody),
            });
            const data = await Response.json();
            // console.log(data)
            if (data.Status == "Success") {
              toast.success(data.Response.Message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
              window.location.reload();
            }
          }
        }
      })
    }
    catch (error) {
      console.error("Error during API call:", error);
    }
  }









  const handleUpdateOpportunity = async () => {
    if (!opportunityData.Emailaddress) {
      toast.warning("Please Select Email", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!opportunityData.Mobilephone) {
      toast.warning("Please Select Mobile Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!opportunityData.Floor) {
      toast.warning("Please Select Floor", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!opportunityData.PostalCode) {
      toast.warning("Please Select Pin Code", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectSolutaton.value === "0") {
      toast.warning("Please Select Solution", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCountry) {
      toast.warning("Please Select Country", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectState.value == "") {
      toast.warning("Please Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity) {
      toast.warning("Please Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea) {
      toast.warning("Please Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!opportunityData.Businesssegment) {
      toast.warning("Please Select Business Segment", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!opportunityData.Subbusinesssegment) {
      toast.warning("Please Select Sub Business Segment", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectTurnOver.value == "0") {
      toast.warning("Please Select Turn Over", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!selectIndustry.value) {
      toast.warning("Please Select Industry Type", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!selectedPriceList.value) {
      toast.warning("Please Select Price List", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!selectedProduct.value) {
      toast.warning("Please Select Product", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    // else if ( Number(opportunityData.otcDiscount) >= Number(opportunityData.OTCAmount)){
    //   toast.warning("OTC Discount should be less than OTC Amount", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // }else if (Number(opportunityData.sdDiscount) >= Number(opportunityData.SDAmount)){
    //   toast.warning("SD Discount should be less than SD Amount", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // }
    else {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL
        const payload = {
          Action: "updateopportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          Remarks: opportunityData.Remarks ? opportunityData.Remarks : "",
          SDWANOpp: {
            applicationsHosted: "",
            currentOperationalCity: "",
            customerBroadbandServices: "",
            customerILLservices: "",
            customerRoutingServices: "No",
            indicationITSpent: " ",
            itSupport: "",
            linksManagedLinks: "",
            mPLSBackbone: "",
            networkSecurityServices: "",
            noOfLocation: " ",
            numberOfLinksBroadbandServices: " ",
            numberOfLinksIll: " ",
            redundancyMPLS: "",
            sdwanRemarks: ""
          },
          area: selectArea.value ? selectArea.value : "",
          buildingNo: opportunityData.BuildingNo ? opportunityData.BuildingNo : "",
          buildingname: "",
          city: selectCity.value ? selectCity.value : "",
          companySelf: "2",
          contactPerson: opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
          country: "10001",
          customerSegment: selectCustomerSeg.value ? selectCustomerSeg.value : "",
          emailaddress: opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
          existingprovider: "",
          firewall: "",
          firmtype: "",
          floor: opportunityData.Floor ? opportunityData.Floor : "",
          industry: selectIndustry.value ? selectIndustry.value : "",
          lco: "",
          media: "1",
          mobilephone: opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
          noOfBeds: " ",
          noOfUsers: " ",
          oppId: OppId ? OppId : "",
          poLock: "",
          poNext: "",
          postalCode: opportunityData.PostalCode ? opportunityData.PostalCode : "",
          priceList: selectedPriceList.value ? selectedPriceList.value : "",
          reason: opportunityData.Reason ? opportunityData.Reason : "",
          redunancy: "0",
          salutation: selectSolutaton.value ? selectSolutaton.value : "",
          specificArea: "",
          specificBuilding: "",
          state: selectState.value ? selectState.value : "",
          topic: opportunityData.Topic ? opportunityData.Topic : "",
          turnOver: selectTurnOver.value ? selectTurnOver.value : "",
          typeOfOrder: "",
          upTimesla: "",
          societyId: selectSociety ? selectSociety?.value : "",
          housePlotFlatNo: opportunityData.HousePlotFlatNo ? opportunityData.HousePlotFlatNo : "",
          blockTowerNumber: opportunityData.BlockTowerNumber ? opportunityData.BlockTowerNumber : "",
          otcAmount: opportunityData.OTCAmount ? opportunityData.OTCAmount : "",
          sdAmount: opportunityData.SDAmount ? opportunityData.SDAmount : "",
          otcAmountDis: "",
          sdAmountDis: "",
          OTCDiscountAmount: opportunityData.otcDiscount ? opportunityData.otcDiscount : "",
          SDDiscountAmount: opportunityData.sdDiscount ? opportunityData.sdDiscount : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };

        // Send API request
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result?.Status === "Success") {
          toast.success("Opportunity updated successfully!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          window.location.reload();
        } else {
          toast.warning("Failed to update opportunity!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      } catch (error) {
        console.error("Error updating opportunity:", error);
        // toast.error("Error updating opportunity.");
      }
      finally {
        setLoading(false);
      }
    }
  };



  useEffect(() => {
    const fetchGetIndustry = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        if (result.Status == "Success") {
          const industryType = result.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          setindustrydropdetails(industryType);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {

      }
    };

    fetchGetIndustry();
  }, []);



  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
          Action: "getPricelist",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          buildingname: selectSociety ? selectSociety : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName')
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        const result = await response.json();

        if (result?.Status === "Success" && result?.Response?.Data) {

          const priceList = result.Response.Data.map(
            (option) => ({
              label: option.PriceName,
              value: option.PriceName,
            })
          );
          setPriceListOptions(priceList);

        } else {
          console.error("Failed to retrieve price list:", result);
        }
      } catch (error) {
        console.error("Error fetching price list:", error);
      }
    }; fetchData();
  }, [selectSociety]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
          Action: "getProductlist",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          oppid: OppId ? OppId : "",
          reason: "",
          siteId: "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };

        // Send API request
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (result?.Status === "Success") {
          // const productList = result.Response.Data.map(item => item.ProductId);
          // console.log("result.Response.Data", result.Response.Data)
          const productList = result.Response.Data.map(
            (option) => ({
              label: option.ProductId,
              value: option.ProductCode,
            })
          );
          setProductOptions(productList);
        }
      } catch (error) {
        console.error("Error fetching product list:", error);
      }
    }; fetchData();
  }, []);


  const handleProductChange = async (selectedOption) => {
    setSelectedProduct(selectedOption);
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "createOppProduct",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        oppid: OppId ? OppId : "",
        password: sessionStorage.getItem('password'),
        productid: selectedOption.label,
        userName: sessionStorage.getItem('userName'),
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responsedata = await response.json();
      if (responsedata.Status == "Failure") {
        toast.warning(responsedata.Response.Message.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

      }

    } catch (error) {
      // Handle fetch error
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      window.location.reload();
    }
  };

  const deleteOppProduct = async (selectedOption) => {
    setSelectedProduct(selectedOption);
    try {
      if (!getOppProduct) { return }

      const deleteOppProduct = await api.deleteOpportunityProduct({ Oppid: OppId, productid: getOppProduct })
      // console.log(deleteOppProduct);

      if (deleteOppProduct?.Response?.StatusCode == 200) {
        toast.success("Product deleted successfully!")
        window.location.reload();
      } else {
        toast.error("Failed to delete Product.")
        window.location.reload();
      }

    } catch (error) {
      // Handle fetch error
      console.error("Error fetching data:", error);
    }
  };

  const redirectoppPage = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/opportunity");
      }
    });
  };

  useEffect(() => {
    const loadOptions = async () => {
      const options = await fetchCompanyData("");
      setCompanyOptions(options);
    };
    loadOptions();
  }, []);

  const fetchCompanyData = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getCompany",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: "New Company",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      //console.log("conpany name :", data.Response.Data);
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((company) => ({
          label: `${company.Company_Name} (${company.Company_ID})`,
          value: company.Company_ID,
          group: `${company.Group_Name} (${company.Group_ID})`,
          groupId: company.Group_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoading(false);
    }
    return [];
  };

  useEffect(() => {
    const loadOptions = async () => {
      const options = await fetchCompanyData("");
      setCompanyOptions(options);
    };
    loadOptions();
  }, []);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectState.value,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityType(cityData.Response.Data);
        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );

          setCityType([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (selectState) {
      fetchCities();
    }
  }, [selectState]);

  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCity(selectedOption);
    setSelectArea("");
    // setSelectBuilding("");
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem('password'),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem('userName'),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :", areaData.Response.Data);
        setAreaList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectArea = async (selectedOption) => {
    setSelectArea(selectedOption);
    // setSelectBuilding("");

  };


  const fetchSocietyData = async (selectedAreaCode) => {
    try {
      const societyApiUrl = process.env.REACT_APP_API_URL_2;
      const societyRequestBody = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: selectedAreaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };
      const societyResponse = await fetch(societyApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(societyRequestBody),
      });
      const societyData = await societyResponse.json();
      // console.log("societyData.Response", societyData.Response);
      if (societyData.Response && Array.isArray(societyData.Response)) {
        setSocietyList(societyData.Response);
      } else {
        toast.warning(societyData.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setSocietyList([]);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
      setSocietyList([]);
    }
  };

  useEffect(() => {
    if (selectArea) {
      const selectedAreaCode = selectArea.value ? selectArea.value : "";
      // console.log("selectedAreaCode",selectedAreaCode);
      fetchSocietyData(selectedAreaCode);
    }
  }, [selectArea]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "black",
      color: "white",
      border: "none",
      boxShadow: state.isFocused ? "none" : provided.boxShadow,
      textAlign: "center",
      fontSize: "15px"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
    }),
    option: (provided, state) => ({
      ...provided,
      // backgroundColor: state.isFocused ? 'blue' : 'black',
      color: "black",
      textAlign: "center",
    }),
  };



  return (
    <>


      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectoppPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-1">Broadband Opportunity</span>
          {statusCode == "Won" && (
            <span className="p-1 flr-createCAf" onClick={handleCreateCaf} style={{ fontSize: "12px" }}>
              Create CAF
            </span>
          )}
        </div>
      </div>
      {/* ************Header end************ */}
      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={load} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid mb-4 form-container">

          {/* {(sdAmountDis && otcAmountDis && statusCode !== "Waiting for Approval" && statusCode !== "Approved" && statusCode !== "Won" && status != "Lost") && (
            <>
              {!(parseFloat(otcAmount) <= parseFloat(otcAmountDis) ||
                parseFloat(sdAmount) <= parseFloat(sdAmountDis)) && (
                  <button
                    type="button"
                    className="btn w-100 mt-2 qualify-btn text-light"
                    onClick={handleSendToApproval}
                  >
                    Submit for Approval
                  </button>
                )}
            </>
          )} */}

          {(sdAmountDis && otcAmountDis && statusCode !== "Waiting for Approval" && statusCode !== "Approved" && statusCode !== "Won" && status != "Lost") && (
            <>
              <button
                type="button"
                className="btn w-100 mt-2 qualify-btn text-light"
                onClick={handleSendToApproval}
              >
                Submit for Approval
              </button>
            </>
          )}

          {/* {(statusCode == "In Progress" || statusCode == "Approved" || statusCode == "Waiting for Approval")  && flag &&  (
            <div>
              <button
                className="btn w-100 mt-2 qualify-btn text-light"
                onClick={handleWon}
              >
                WON
              </button>
            </div>)}  */}


          {(statusCode === "In Progress" &&
            (!sdAmountDis && !otcAmountDis)) ||
            (statusCode === "Approved" &&
              opportunityData.otcDiscount &&
              opportunityData.sdDiscount) ? (
            <div>
              <button
                className="btn w-100 mt-2 qualify-btn text-light"
                onClick={handleWon}
              >
                WON
              </button>
            </div>
          ) : null}


          {statusCode !== "Won" &&
            <div className='mt-2'>
              <Select
                className="basic-single disqualify-select"
                classNamePrefix="select"
                name="subBusiness"
                // value={selectQualify}
                isSearchable={false}
                styles={customStyles}
                value={{ value: "", label: "LOST" }} // Value should be an object with 'value' and 'label' properties
                onChange={handleLost}
                options={optionLost.map((data) => ({
                  value: data.code,
                  label: data.name,
                }))}
              />
            </div>}

          {/* {statusCode !== "Won" &&
            <div>
              <button
                className="btn w-100 mt-2 qualify-btn text-light"
                onClick={handleLost}
              >
                LOST
              </button>
            </div>} */}

          {/* **************Opportunity Details toggle******************* */}
          <div className="contact-toggle mt-3" onClick={() => handleIconClick("form1")}
          >
            <span className="toggle-text">Opportunity Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form1" && (
            <div className=" container shadow  mb-3 bg-body rounded mt-4" id="form1">
              <form className="contact-form p-2">


                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Mobile Phone"
                    className="form-control input-text form-control-sm mt-1"
                    id="Topic"
                    name="Topic"
                    value={opportunityData.Topic || ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="mobilephone" className='mt-2'>Topic*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Opportunity ID"
                    className="form-control input-text form-control-sm mt-1"
                    id="Opportunity"
                    name="OppId"
                    value={opportunityData.OppId || ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="Opportunity" className='mt-2'>Opportunity ID*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Opportunity ID"
                    className="form-control input-text form-control-sm mt-1"
                    id="Opportunity"
                    name="OppId"
                    value={opportunityData.OppStatus || ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="Opportunity" className='mt-2'>Opportunity Status*</label>
                </div>


                <div className="">
                  <label className="select-search-label mt-1">Company*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="company"
                    value={selectedCompany}
                    onChange={handleCompanyChange}
                    options={companyOptions}
                    styles={style}
                    isSearchable={true}
                    isLoading={loader}
                    placeholder="Select Company"
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Lead Name"
                    className="form-control input-text form-control-sm mt-1"
                    id="leadname"
                    name="leadname"
                    value={opportunityData.leadname || ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="leadname" className='mt-2'>Lead Name*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Email Address"
                    className="form-control input-text form-control-sm mt-1"
                    id="email"
                    name="Emailaddress"
                    value={opportunityData.Emailaddress}
                    onChange={handleChange}
                  />
                  <label htmlFor="email" className='mt-2'>Email*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Mobile Phone"
                    className="form-control input-text form-control-sm mt-1"
                    id="mobilephone"
                    name="Mobilephone"
                    value={opportunityData.Mobilephone}
                    onChange={handleChange}
                  />
                  <label htmlFor="mobilephone" className='mt-2'>Mobile Phone*</label>
                </div>


                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Floor"
                    className="form-control input-text form-control-sm mt-1"
                    id="floor"
                    name="Floor"
                    value={opportunityData.Floor}
                    onChange={handleChange}
                  />
                  <label htmlFor="floor" className='mt-2'>Floor*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Pin Code"
                    className="form-control input-text form-control-sm mt-1"
                    id="pin"
                    name="PostalCode"
                    value={opportunityData.PostalCode || ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="pin" className='mt-2'>Pin Code*</label>
                </div>
              </form>
            </div>
          )}
          {/* **************Contact Person Details toggle******************* */}
          <div className="Lead-Channel-toggle mt-3" onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">Contact Person Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form2" && (
            <div className="container shadow mb-3 bg-body rounded mt-4" id="form2">
              <form className="Lead-Channel-form p-2">

                <div className="">
                  <label className="select-search-label mt-1">
                    Salutation*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="Salutation"
                    placeholder="Select Salutation"
                    styles={style}
                    value={selectSolutaton}
                    isSearchable={false}
                    onChange={handleSelectSolutation}
                    options={optionSolutation.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Contact Person Name"
                    className="form-control input-text form-control-sm mt-1"
                    id="contactPerson"
                    name="ContactPerson"
                    value={opportunityData.ContactPerson || ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="contactPerson" className='mt-2'>Contact Person Name*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Email"
                    className="form-control input-text form-control-sm mt-1"
                    id="contactEmail"
                    name="Emailaddress"
                    value={opportunityData.Emailaddress || ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="contactEmail" className='mt-2'>Email*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    className="form-control input-text form-control-sm mt-1"
                    id="contactMobile"
                    name="Mobilephone"
                    value={opportunityData.Mobilephone}
                    onChange={handleChange}
                  />
                  <label htmlFor="contactMobile" className='mt-2'>Mobile Number*</label>
                </div>


                <div className="">
                  <label className="select-search-label mt-1">Country*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="Country"
                    placeholder="Select Country"
                    styles={style}
                    isSearchable={false}
                    value={selectCountry}
                    onChange={handleSelectCountry}
                    options={optionCountry.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustrySeg"
                    placeholder="Select State"
                    isSearchable={false}
                    styles={style}
                    value={selectState}
                    onChange={handleSelectState}
                    options={optionState.map((data) => ({
                      value: data.code,
                      label: data.name,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">City*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="City"
                    placeholder="Select City"
                    isSearchable
                    styles={style}
                    // value={cityType.find(
                    //   (city) => city.CityCode === selectCity.value
                    // )}
                    value={selectCity}
                    onChange={handleSelectCity}
                    options={cityType.map((data) => ({
                      value: data.CityCode,
                      label: data.CityName,
                    }))}
                  />
                </div>

                <div className="search-area" style={{ position: "relative" }}>
                  <label className="select-search-label mt-1">Area*</label>
                  <Select
                    options={areaList.map((area) => ({
                      value: area.AreaCode,
                      label: `${area.AreaName} (${area.AreaCode})`,
                    }))}
                    className=" form-control form-control-sm p-1 custom-select"
                    placeholder="Search Area"
                    isSearchable
                    styles={style}
                    value={selectArea}
                    onChange={handleSelectArea}
                  />
                  <i
                    className="fas fa-search text-secondary"
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "63%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>

                <div className="">
                  <label className="select-search-label mt-1">Society*</label>
                  <Select
                    className="basic-single form-control form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="Society"
                    placeholder="Select Society"
                    isSearchable
                    styles={style}
                    value={selectSociety}
                    onChange={handleSelectSociety}
                    options={societyList.map((data) => ({
                      value: data.SocietyCode,
                      label: data.SocietyName,
                    }))}
                  />
                </div>



                {/* <div className="input-box form-floating">
                  <input
                    type="search"
                    placeholder="Society Name"
                    className="form-control input-text form-control-sm mt-1"
                    id="SocietyName"
                    name="SocietyName"
                    value={opportunityData.SocietyName}
                    onChange={handleChange}
                  />
                  <label htmlFor="SocietyName" className="mt-2">Society Name*</label>
                </div> */}


                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Floor"
                    className="form-control input-text form-control-sm mt-1"
                    id="floor"
                    name="Floor"
                    value={opportunityData.Floor}
                    onChange={handleChange}
                  />
                  <label htmlFor="floor" className='mt-2'>Floor*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Pin Code"
                    className="form-control input-text form-control-sm mt-1"
                    id="pin"
                    name="PostalCode"
                    value={opportunityData.PostalCode}
                    onChange={handleChange}
                  />
                  <label htmlFor="pin" className='mt-2'>Pin*</label>
                </div>
              </form>
            </div>
          )}
          {/* **************Company Details toggle******************* */}
          <div className="Company-details-toggle mt-3" onClick={() => handleIconClick("form5")}
          >
            <span className="toggle-text">Company Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form5" && (
            <div className="container shadow mb-3 bg-body rounded mt-4" id="form5">
              <form className="Company-details-form p-2">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Company Name"
                    className="form-control input-text form-control-sm mt-1"
                    id="company"
                    name="Companyname"
                    value={opportunityData.Companyname}
                    onChange={handleChange}
                  />
                  <label htmlFor="company" className='mt-2'>Company Name*</label>
                </div>


                <div className="">
                  <label className="select-search-label mt-1">
                    Industry Type*
                  </label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    placeholder="Select Option"
                    id="IndustryType"
                    name="IndustryType"
                    styles={style}
                    value={selectIndustry}
                    // isDisabled={true}
                    onChange={handleIndustryChnage}
                    options={industrydropdetails.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}

                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Business Segment"
                    className="form-control input-text form-control-sm mt-1"
                    id="businessSegment"
                    name="Businesssegment"
                    value={opportunityData.Businesssegment}
                    isDisabled={true}
                  />
                  <label htmlFor="businessSegment" className='mt-2'>Business Segment*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder="Sub Business Segment"
                    className="form-control input-text form-control-sm mt-1"
                    id="subBusinessSegment"
                    name="Subbusinesssegment"
                    value={opportunityData.Subbusinesssegment}
                    isDisabled={true}
                  />
                  <label htmlFor="subBusinessSegment" className='mt-2'>Sub Business Segment*</label>
                </div>


                <div className="">
                  <label className="select-search-label mt-1">
                    Account Turn Over*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="selectTurnOver"
                    placeholder="Select Option"
                    styles={style}
                    value={selectTurnOver}
                    isSearchable={false}
                    onChange={handleSelectTurnOver}
                    options={optionTurnOver.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>




              </form>
            </div>
          )}



          <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form9")}
          >
            <span className="toggle-text">Product Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
          {activeForm === "form9" && (
            <div className="container shadow mb-3 bg-body rounded mt-4" id="form9">
              <form className="Remarks-form p-2">

                <div className="Other-details-toggle mt-3">
                  <form className="Other-details-form p-2">

                    <div className="">
                      <label className="select-search-label mt-1">
                        Price list*
                      </label>
                      <Select
                        className=" basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        name="Price"
                        placeholder="Select Price List"
                        styles={style}
                        value={selectedPriceList}
                        isSearchable={true}
                        onChange={handlePriceListChange}
                        options={priceListOptions.map((data) => ({
                          value: data.value,
                          label: data.label,
                        }))}
                      />
                    </div>

                    {/* {console.log("selectedProduct",selectedProduct.value)} */}
                    <div className="search-area" style={{ position: "relative" }}>
                      <label className="select-search-label mt-1">
                        Product list*
                      </label>
                      <Select
                        className=" basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        name="Product"
                        placeholder="Select Product"
                        styles={style}
                        value={selectedProduct}
                        isSearchable={true}
                        onChange={handleProductChange}
                        options={productOptions.map((data) => ({
                          value: data.value,
                          label: data.label,
                        }))}
                        isDisabled={!!selectedProduct?.value}
                      />
                      {selectedProduct?.value &&
                        <i
                          className="fa fa-trash"
                          onClick={() => deleteOppProduct(null)}
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "63%",
                            transform: "translateY(-50%)",
                          }}
                        ></i>}
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter reason"
                        className="form-control input-text form-control-sm mt-1"
                        id="reason"
                        name="Reason"
                        value={opportunityData.Reason}
                        onChange={handleChange}
                        style={{ background: "transparent" }}
                        readOnly
                      />
                      <label htmlFor="reason" className="mt-2">Reason</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter RC Amount"
                        className="form-control input-text form-control-sm mt-1"
                        id="rcAmount"
                        name="RCAmount"
                        value={opportunityData.RCAmount || ""}
                        onChange={handleChange}
                        disabled
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="rcAmount" className="mt-2">RC Amount</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter OTC Amount"
                        className="form-control input-text form-control-sm mt-1"
                        id="otcAmount"
                        name="OTCAmount"
                        value={opportunityData.OTCAmount || ""}
                        onChange={handleChange}
                        disabled
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="otcAmount" className="mt-2">OTC Amount</label>
                    </div>


                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter SD Amount"
                        className="form-control input-text form-control-sm mt-2"
                        id="otcDiscount"
                        name="otcDiscount"
                        value={opportunityData.otcDiscount || ""}
                        onChange={handleChange}
                        disabled={statusCode !== "In Progress"}
                        style={{ background: "transparent" }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];
                          const isDigit = /\d/.test(e.key);
                          if (
                            (isDigit || allowedKeys.includes(e.key)) &&
                            (opportunityData.otcDiscount.length < 10 || e.key === "Backspace")
                          ) {
                            return true;
                          } else {
                            e.preventDefault();
                          }
                        }}
                      />
                      <label htmlFor="sdAmount" className="mt-2">OTC Discount</label>
                    </div>

                    {/* {console.log("opportunityData.otcDiscount", opportunityData.otcDiscount)} */}

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter SD Amount"
                        className="form-control input-text form-control-sm mt-2"
                        id="discount"
                        name="discount"
                        value={opportunityData.exOtcDiscount || ""}
                        onChange={handleChange}
                        disabled
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="sdAmount" className="mt-2">Extended OTC Amount</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter SD Amount"
                        className="form-control input-text form-control-sm mt-2"
                        id="sdAmount"
                        name="SDAmount"
                        value={opportunityData.SDAmount || ""}
                        onChange={handleChange}
                        disabled
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="sdAmount" className="mt-2">SD Amount</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter SD Amount"
                        className="form-control input-text form-control-sm mt-2"
                        id="sdDiscount"
                        name="sdDiscount"
                        value={opportunityData.sdDiscount || ""}
                        onChange={handleChange}
                        disabled={statusCode !== "In Progress"}
                        style={{ background: "transparent" }}
                        onKeyDown={(e) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ];
                          const isDigit = /\d/.test(e.key);
                          if (
                            (isDigit || allowedKeys.includes(e.key)) &&
                            (opportunityData.sdDiscount.length < 10 || e.key === "Backspace")
                          ) {
                            return true;
                          } else {
                            e.preventDefault();
                          }
                        }}
                      />
                      <label htmlFor="sdAmount" className="mt-2">SD Discount</label>
                    </div>

                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder="Enter SD Amount"
                        className="form-control input-text form-control-sm mt-2"
                        id="discount"
                        name="discount"
                        value={opportunityData.exsdDiscount || ""}
                        onChange={handleChange}
                        disabled
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="sdAmount" className="mt-2">Extended SD Amount</label>
                    </div>


                  </form>
                </div>

              </form>
            </div>)}

          <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form7")}
          >
            <span className="toggle-text">Remarks</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form7" && (
            <div className="container shadow mb-3 bg-body rounded mt-4" id="form7">
              <form className="Remarks-form p-2">
                <div className="input-box form-floating">
                  <input type="text" placeholder="" className=" form-control input-text form-control-sm mt-1" id="Remarks"
                    name="Remarks" value={opportunityData.Remarks} onChange={handleChange} />
                  <label htmlFor="floatingInput" className="mt-2">Remarks</label>
                </div>
              </form>
            </div>)}


          <div className=" text-center mt-5 mb-3">
            <button
              type="submit"
              className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
              onClick={handleUpdateOpportunity}
            >
              Update
            </button>
          </div>

        </div>
      )}
    </>
  );
};

export default OpportunityForm;
